export const enCase01Messages = {
  "intro-page.case01.title": `About ATMOS Truck`,
  "intro-page.case01.navbarTitle": `Atmos Truck Live Streaming`,
};
